/** Read Telegram's signed launch data before navigation, without waiting for its SDK. */
export const TMA_INIT_DATA_KEY = 'gonkagame_tma_init_data'

export function isTelegramMiniAppContext(): boolean {
  return Boolean(window.Telegram?.WebApp?.initData && window.Telegram?.WebApp?.platform !== 'unknown')
    || 'TelegramWebviewProxy' in window
    || 'TelegramWebview' in window
    || 'TelegramWebviewProxyProto' in window
}

export function clearTelegramInitData(): void {
  rejectedLaunch = false
  try {
    sessionStorage.removeItem(TMA_INIT_DATA_KEY)
    sessionStorage.removeItem('__telegram__initParams')
  } catch { /* ignore */ }
  if (hasTelegramLaunchParams()) {
    try {
      window.history.replaceState(null, '', window.location.pathname || '/')
    } catch { /* ignore */ }
  }
}

let rejectedLaunch = false

function pickLaunchParam(raw: string): string | null | undefined {
  for (const pair of raw.replace(/^[#?]/, '').split('&')) {
    if (pair === 'tgWebAppData') return null
    const eq = pair.indexOf('=')
    if (eq === -1 || pair.slice(0, eq) !== 'tgWebAppData') continue
    if (pair.slice(eq + 1) === '') return null
    try {
      // URLSearchParams would turn literal '+' into spaces and break the signature.
      return decodeURIComponent(pair.slice(eq + 1))
    } catch {
      return null
    }
  }
  return undefined
}

export function hasTelegramLaunchParams(): boolean {
  return pickLaunchParam(window.location.hash) !== undefined
    || pickLaunchParam(window.location.search) !== undefined
}

export function readTelegramInitData(sdkInitData: string | null = null): string | null {
  const fromHash = pickLaunchParam(window.location.hash)
  const fromLocation = fromHash !== undefined ? fromHash : pickLaunchParam(window.location.search)

  if (fromLocation !== undefined) {
    rejectedLaunch = fromLocation === null
    try {
      // Persist rejection too: reload must not fall back to a previous SDK user.
      sessionStorage.setItem(TMA_INIT_DATA_KEY, fromLocation ?? '')
    } catch { /* Storage is optional for the initial launch. */ }
    return fromLocation
  }

  if (rejectedLaunch) return null
  try {
    const cached = sessionStorage.getItem(TMA_INIT_DATA_KEY)
    return cached === '' ? null : cached ?? (sdkInitData || null)
  } catch {
    return sdkInitData || null
  }
}
